import './OkulyonetimProduct.scss'

import { CheckCircleFilled, FilePdfOutlined, HeartFilled, HeartOutlined, StarFilled } from '@ant-design/icons'
import { Button, notification } from 'antd'
import React, { useState } from 'react'

import { AppRoutes } from '../../../App'
import { useFavoriEkleMutation, useSinifaUrunEkleMutation } from '../../../gql/GeneratedGraphqlTypes'
import { getFormattedPrice } from '../../../helpers/Formatting'
import { ReactComponent as Logo } from '../../../images/okulyonetim/add-class.svg'
import OkulyonetimAddToClassModal from '../okulyonetim-add-to-class-modal/OkulyonetimAddToClassModal'
import OkultonetimSuccessModal from '../okulyonetim-added-product-model/OkulyonetimSuccessModal'
import { OkulyonetimProductType } from './type'
const OkulyonetimProduct: React.FC<OkulyonetimProductType> = (props) => {
  const { image, price, id, title, pdf, pdf_url, quantity, initialIsFavori, onFavoriteChange, mufredat, oneri } = props
  const [isFavori, setIsFavori] = useState(initialIsFavori)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [successModalVisible, setSuccessModalVisible] = useState(false)
  const [successMessage, setSuccessMessage] = useState('')
  const [returnedDersler, setReturnedDersler] = useState<string[]>([])
  const [sinifaUrunEkleMutation] = useSinifaUrunEkleMutation()
  const [favoriEkleMutation] = useFavoriEkleMutation()
  const [selectedItems, setSelectedItems] = useState<{ sinifId: number; sinifDersId: number }[]>([])
  const [inputValue, setInputValue] = useState<number | null>(quantity!)

  const showModal = () => {
    setIsModalOpen(true)
  }

  const handleOk = async (selectedItems: { sinifId: number; sinifDersId: number }[]) => {
    const dersler = selectedItems.map((item) => item.sinifDersId)
    try {
      const response = await sinifaUrunEkleMutation({
        variables: {
          input: {
            urun_id: id!,
            adet: inputValue!,
            dersler: dersler,
          },
        },
      })
      if (response.data?.sinifaUrunEkle?.success) {
        setIsModalOpen(false)
        setSuccessMessage(response.data.sinifaUrunEkle.message || 'İşlem başarılı')

        const derslerListesi = (response.data.sinifaUrunEkle.dersler || []).filter(
          (ders): ders is string => ders !== null,
        )

        setReturnedDersler(derslerListesi)
        setSuccessModalVisible(true)
        setSelectedItems([])
      } else {
        setIsModalOpen(false)
      }
    } catch (error) {
      // Hata mesajı göster
      notification.error({
        message: '',
        description: `'Ürün güncellenirken bir hata oluştu.'.`,
        duration: 6,
      })
    }
  }

  const handleCancel = () => {
    setIsModalOpen(false)
  }

  const handleFavorite = async () => {
    try {
      const response = await favoriEkleMutation({
        variables: {
          input: {
            urun_id: id!,
          },
        },
      })
      if (response.data?.favoriEkle.success) {
        notification.success({
          message: '',
          description: `${response.data?.favoriEkle?.message}`,
          duration: 6,
        })
        setIsFavori(!isFavori)
        if (onFavoriteChange) {
          onFavoriteChange() // Favori değişikliğinden sonra tetikle
        }
      } else {
        notification.error({
          message: '',
          description: `${response.data?.favoriEkle?.message || 'Bir hata oluştu'}`,
          duration: 6,
        })
      }
    } catch (error) {
      // Hata mesajı göster
      notification.error({
        message: '',
        description: `'Favori işlemi sırasında bir hata oluştu.'.`,
        duration: 6,
      })
    }
  }

  return (
    <div className="okulyonetim-product">
      <div className="okulyonetim-product-image">
        <div
          onClick={() =>
            window.open(
              `/v1/${AppRoutes.okulyonetim.base}/${AppRoutes.okulyonetim.productDetail}/${id}`,
              '_blank',
              'noopener,noreferrer',
            )
          }
        >
          <img src={image} alt="" />
        </div>
        <div
          className="okulyonetim-product-image-text"
          onClick={() =>
            window.open(
              `/v1/${AppRoutes.okulyonetim.base}/${AppRoutes.okulyonetim.productDetail}/${id}`,
              '_blank',
              'noopener,noreferrer',
            )
          }
        >
          {title && title.length > 60 ? `${title.substring(0, 60)}...` : title}
        </div>
      </div>
      <div className="okulyonetim-product-info">
        <div className="okulyonetim-product-info-price">
          {!price || price <= 0.1 ? 'Ürün fiyatı belli değil' : <span>{getFormattedPrice(price.toString())} TL</span>}
        </div>

        <div className="okulyonetim-product-info-add">
          <Button className="okulyonetim-product-info-add-basket" onClick={showModal}>
            <Logo />
            <span id="add-to-class">Sınıfa Ekle</span>
          </Button>
          <div className="okulyonetim-product-info-add-favorite" onClick={handleFavorite}>
            {isFavori ? (
              <HeartFilled
                style={{
                  color: '#2C7222',
                }}
              />
            ) : (
              <HeartOutlined
                style={{
                  color: '#978D8D',
                }}
              />
            )}
          </div>
        </div>
      </div>
      <div className="okulyonetim-product-buttons">
        {pdf_url && (
          <div
            className="okulyonetim-product-buttons-excel"
            onClick={() => window.open(pdf_url, '_blank', 'noopener,noreferrer')}
          >
            <FilePdfOutlined />
          </div>
        )}
        {pdf && (
          <div
            className="okulyonetim-product-buttons-pdf"
            onClick={() => {
              const link = document.createElement('a')
              link.href = pdf
              link.download = pdf.split('/').pop() || 'file.pdf' // Dosya adını belirleme
              link.target = '_blank'
              document.body.appendChild(link)
              link.click()
              document.body.removeChild(link) // Temizlik işlemi
            }}
          >
            <FilePdfOutlined />
          </div>
        )}
        {mufredat && (
          <span className="first-banner">
            <CheckCircleFilled className="banner-icons" /> 2025 Müfredatı
          </span>
        )}
        {oneri && (
          <span className="second-banner">
            <StarFilled className="banner-icons" /> Öneriyoruz
          </span>
        )}
      </div>
      <OkulyonetimAddToClassModal
        image={image!}
        title={title!}
        inputValue={inputValue}
        setInputValue={setInputValue}
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}
        price={price!}
        quantity={quantity}
        isModalOpen={isModalOpen}
        handleOk={handleOk}
        handleCancel={handleCancel}
      />
      <OkultonetimSuccessModal
        isModalVisible={successModalVisible}
        image={image!}
        title={title!}
        price={price!}
        quantity={quantity}
        message={successMessage}
        dersler={returnedDersler}
        handleOk={() => setSuccessModalVisible(false)}
      />
    </div>
  )
}

export default OkulyonetimProduct
